<script setup lang="tsx">
import { computed } from 'vue'
import HeaderComponent from '../shared/HeaderComponent.vue'
import IconButton from '../shared/IconButton.vue'
import { PermAdminInstances } from '@/models/enums-generated'
import sliderStore from '@/stores/slider'
import InstanceTable from './InstanceTable.vue'
import { hasPermission } from '@/services/utils'

const slider = sliderStore()
const canAdd = computed(() => hasPermission(PermAdminInstances))
</script>

<template>
	<HeaderComponent :title="$t('instance')">
		<template #right-side>
			<div class="d-flex align-items-center gap-2">
				<IconButton
					v-if="canAdd"
					data-test="open-new-instance"
					:title="$t('misc.add')"
					class="bi bi-plus-square"
					@click="slider.openInstance"
				>
				</IconButton>
			</div>
		</template>
	</HeaderComponent>
	<InstanceTable></InstanceTable>
</template>

<style lang="sass" scoped></style>
